import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { NewDummyRoomEditContainer } from "@/components/features/items/edit/room/dummy/default/ui/new";

import { useGetNewRoomParams } from "../_hooks/use-get-new-room-params";

export const NewDummyRoomEditPage = () => {
	const { hotelID, duplicateItemID } = useGetNewRoomParams();

	return (
		<PageMeta
			title="新規ダミー部屋の作成"
			url={generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.NEW.DUMMY.DEFAULT, { hotelID })}
		>
			<NewDummyRoomEditContainer hotelID={hotelID} roomID={duplicateItemID ?? undefined} />
		</PageMeta>
	);
};
